import { CoreCsvUploadType } from '@repo/csv'

export const MATERIALS_UPLOAD_TYPES: CoreCsvUploadType[] = [
  'material-specification-conversion',
  'merchandise',
] as const
